"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const scale_1 = require("../../../utils/scale");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const ItemArticles_1 = __importDefault(require("../../HomeScreen/components/ItemArticles"));
const IC_RIGHT_1 = __importDefault(require("../../../assets/icons/IC_RIGHT"));
const ItemHashtag = (props) => {
    const { data, onOpenHashtag } = props;
    return (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(react_native_1.Pressable, { style: {
                flexDirection: "row",
                height: (0, scale_1.scale)(30),
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
            }, onPress: onOpenHashtag },
            react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
                react_1.default.createElement(CustomText_1.default, { style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: "#007AFF",
                    } }, `#${data?.hash_tag_name}`),
                react_1.default.createElement(CustomText_1.default, { style: {
                        fontSize: (0, scale_1.moderateScale)(11),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: "#7C7C7C",
                        marginLeft: (0, scale_1.scale)(12),
                    } }, `${data?.count}件`)),
            react_1.default.createElement(IC_RIGHT_1.default, { width: (0, scale_1.scale)(12), height: (0, scale_1.scale)(12) })),
        react_1.default.createElement(react_native_1.ScrollView, { contentContainerStyle: { paddingRight: (0, scale_1.scale)(20) }, showsHorizontalScrollIndicator: scale_1.isPC, horizontal: true, style: {
                flexDirection: "column",
                flexWrap: "wrap",
                paddingLeft: (0, scale_1.scale)(16),
            } }, data.articles.map((item, index) => {
            return react_1.default.createElement(ItemArticles_1.default, { data: item, key: index });
        }))));
};
exports.default = ItemHashtag;
